<template>
  <div class="im-custom-invite-referral" :class="{ right: isMe }">
    <div class="info-wrap" :class="[`type${messageContext.checkState}`]" @click="link">
      <div class="avatar">
        <img
          v-if="String(messageContext.checkState) === '0'"
          alt=""
          src="https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/invite_refferal_type.png"
          class="image"
        />
        <img
          alt=""
          v-if="String(messageContext.checkState) === '1'"
          src="https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/invite_refferal_type1.png"
          class="image"
        />
        <img
          v-if="String(messageContext.checkState) === '2'"
          alt=""
          src="https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/invite_refferal_type2.png"
          class="image"
        />
        <img
          v-if="String(messageContext.checkState) === '3'"
          alt=""
          src="https://pharmacyimg.docbook.com.cn/remote_collaborative_clinic_app/invite_refferal_type3.png"
          class="image"
        />
      </div>
      <div class="info">
        <div class="title">邀请专业支持单</div>
        <div class="subtitle">{{ invitationMessage }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { toInviteReferralDetail } from '@/timpackage/utils/timInit'
// 药品展示组件
export default {
  name: 'ImCustomInviteReferral',
  props: {
    message: {
      // im消息结构体
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {
      // id: 0,
      // userID: '',
      // applyHospitalID: '',
      // applyHospitalName: '',
      // applyDeptID: '',
      // applyDeptName: '',
      // applyDoctorID: '',
      // applyDoctorName: '',
      // applyDoctorPhone: '',
      // toHospitalID: '',
      // toHospitalName: '',
      // toDeptID: '',
      // toDeptName: '',
      // patientID: '',
      // patientName: '',
      // patientSex: '',
      // patientCardType: '',
      // patientCardNo: '',
      // patientAge: '',
      // patientAddress: '',
      // patientPhone: '',
      // checkState: '',
      // checkTime: '2024-07-30T16:18:36.703991600',
      // preImpress: '',
      // medicalCurrentDesc: '',
      // medicalHistoryDesc: '',
      // treatProcess: '',
      // createTime: '2024-07-30T16:18:36.703991600',
      // updateTime: '2024-07-30T16:18:36.703991600',
      // visitID: '',
      // type: 0
    }
  },
  computed: {
    isMe() {
      // 自己发送的消息
      return this.message.flow === 'out'
    },
    messageContext() {
      // 处方信息
      const data = JSON.parse(this.message.payload.data)
      return data.content
    },
    invitationMessage() {
      if (this.isMe) {
        if (String(this.messageContext.checkState) === '0') {
          return this.isMe ? '您发起了邀请专业支持单' : '远程专家发起了邀请专业支持单'
        }
      }
      if (String(this.messageContext.checkState) === '1') {
        return '医生已确认专业支持'
      }
      if (String(this.messageContext.checkState) === '2') {
        return '医生已拒绝专业支持'
      }
      if (String(this.messageContext.checkState) === '3') {
        return '医生已取消专业支持'
      }
      return '邀请专业支持单'
    }
  },
  methods: {
    link() {
      // 跳转转诊详情
      this.messageContext && toInviteReferralDetail(this.messageContext.referralId)
    }
  }
}
</script>

<style lang="scss" scoped>
.im-custom-invite-referral {
  background: #ffffff;
  box-shadow: 0 0.106667rem 0.213333rem 0 rgb(0 0 0 / 10%);
  border-radius: 0.256rem;

  .info-wrap {
    padding: 0.341333rem 0.490667rem 0.341333rem 0.341333rem;
    display: flex;
    align-items: flex-start;
    .avatar {
      flex: 0 0 auto;
      // width: .853333rem;
      // height: .853333rem;
      // border-radius: 1.28rem;
      // overflow: hidden;

      & > .image {
        display: block;
        width: 0.853333rem;
        height: 0.853333rem;
      }
    }
    .info {
      margin-left: 0.256rem;
      flex: 1;
      .title {
        font-size: 0.597333rem;
        line-height: 0.853333rem;
        color: #56c08d;
      }

      .subtitle {
        margin-top: 0.085333rem;
        font-size: 0.512rem;
        line-height: 0.853333rem;
        font-weight: 400;
        color: #777777;
      }
    }

    &.type0 {
      // 待审核
      .info {
        .title {
          color: #366ef4;
          // color: #fa9550;
        }
      }
    }

    &.type1 {
      // 已通过
      .info {
        .title {
          color: #56c08d;
        }
      }
    }

    &.type2 {
      // 已拒绝
      .info {
        .title {
          color: #ff5b5b;
        }
      }
    }
    &.type3 {
      // 已撤销
      .info {
        .title {
          color: #a6a6a6;
        }
      }
    }
  }
}
</style>
